(function () {
    
    let modalDefaultSettings = {
        // modal: true,
        
        closeExisting: true,
        smallBtn: true,
        touch: false,
        autoFocus: false,
        
        buttons: [
            "close"
        ],
        btnTpl: {
            smallBtn:
            '<button data-fancybox-close class="fancybox-modal-close-custom" title="{{CLOSE}}">' +
            '<svg fill="none" xmlns="http://www.w3.org/2000/svg">\n' +
            '<rect width="20.5702" height="2.05702" rx="1.02851" transform="matrix(0.707104 0.707109 -0.707104 0.707109 1.4541 0.000244141)" fill="#949599" stroke="#949599" stroke-width="0.3"/>\n' +
            '<rect width="20.5702" height="2.05702" rx="1.02851" transform="matrix(0.707104 -0.707109 0.707104 0.707109 0.000976562 14.5454)" fill="#949599" stroke="#949599" stroke-width="0.3"/>\n' +
            '</svg>' +
            '</button>'
        },
        
        baseTpl:
        '<div class="fancybox-container" role="dialog" tabindex="-1">' +
        '<div class="fancybox-bg"></div>' +
        '<div class="fancybox-stage"></div>' +
        '</div>',
        baseClass: "fancybox-modal-custom",
        
        clickOutside: "close",
        
        afterShow: function( instance, slide ) {
            const $wrapper = slide.$slide.find(".js-modal-content-inner");
            if ($wrapper.length > 0) {
                new SimpleBar($wrapper[0]);
            }
            slide.$slide.find (".fancybox-content").trigger ("is:open");
        },
        
        lang: "ru",
        i18n: {
            en: {
                CLOSE: "Close",
                NEXT: "Next",
                PREV: "Previous",
                ERROR: "The requested content cannot be loaded. <br/> Please try again later.",
                PLAY_START: "Start slideshow",
                PLAY_STOP: "Pause slideshow",
                FULL_SCREEN: "Full screen",
                THUMBS: "Thumbnails",
                DOWNLOAD: "Download",
                SHARE: "Share",
                ZOOM: "Zoom"
            },
            ru: {
                CLOSE: "Закрыть",
                NEXT: "След.",
                PREV: "Пред.",
                ERROR: "Невозможно загрузить контент. <br/> Пожалуйста, попробуйте позднее.",
                PLAY_START: "Начать слайдшоу",
                PLAY_STOP: "Поставить на паузу",
                FULL_SCREEN: "Во весь экран",
                THUMBS: "Превью",
                DOWNLOAD: "Скачать",
                SHARE: "Поделиться",
                ZOOM: "Увеличить"
            }
        }
    };
    
    $.fn.extend({
        iModalInit: function ( userSettings = {} ) {
            const settings = Object.assign({}, modalDefaultSettings, userSettings)
            $(this).fancybox( settings )
        },
        
        iModalOpen: function ( userSettings = {} ) {
            const settings = Object.assign({}, modalDefaultSettings, userSettings)
            $.fancybox.open({
                src  : $(this),
                type : 'inline',
                opts : settings
            })
        }
    });
    
    $(function () {
        
        $( "[data-fancybox]" ).each( function () {
            let settings = {};
            if ($( this ).attr("data-fancybox-settings")) {
                settings = JSON.parse($( this ).attr("data-fancybox-settings"));
            }
            $( this ).iModalInit(settings);
        });
    })
}());
